import React, { useState } from "react";
import { Link } from "react-router-dom";
import { logo } from "../../constants";

const SellerHeader = () => {
	const [category, showcategory] = useState(false);
	function showcard() {
		showcategory(true);
	}
	function hidecard() {
		showcategory(false);
	}
	return (
		<>
			{/* <!-- feedback modals ends here --> */}
			<div
				className="modal fade rev"
				id="staticBackdrop"
				data-bs-backdrop="static"
				data-bs-keyboard="false"
				tabIndex="-1"
				aria-labelledby="staticBackdropLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog">
					<div className="modal-content">
						<button
							type="button"
							className="btn-close"
							data-bs-dismiss="modal"
							aria-label="Close"
						>
							{/* <span aria-hidden="true">&times;</span> */}
						</button>
						<div className="modal-body text-center">
							<h4>Feedback</h4>
							<form action="">
								<div className="form-group">
									<textarea
										name=""
										placeholder="Lorem Ipsum"
										className="form-control"
										id=""
										cols="30"
										rows="5"
									></textarea>
								</div>
								<div className="form-group mt-3">
									<button className="btn form-control">Send Feedback</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
			{/* <!-- feedback modals ends here --> */}
			<header id="header">
				<div className="top-header-wrapper">
					<div className="container-fluid">
						<div className="row align-items-center">
							<div className="col-lg-2">
								<div className="logo-wrapper">
									<Link to="/seller-dashboard">
										<img src={logo} className="img-fluid" alt="" />
									</Link>
								</div>
							</div>
							<div className="col-lg-6"></div>
							<div className="col-lg-4">
								<div className="header-menu-icons-wrapper">
									<ul style={{ justifyContent: "end" }}>
										<li className="phone-no">
											<h6>8800 332 65-66</h6>
											<span>Support 24/7</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="main-header-wrapper">
					<div className="container-fluid">
						<div className="row">
							<div className="col-lg-2"></div>
							<div className="col-lg-6"></div>
							<div className="col-lg-4">
								<div className="menu-items-wrapper">
									<ul>
										<li className="nav-item">
											<a href="/seller-dashboard" className="nav-link">
												Dashboard
											</a>
										</li>
										<li className="nav-item">
											<a href="/about" className="nav-link">
												About
											</a>
										</li>
										<li className="nav-item">
											<a href="/contact" className="nav-link">
												Contact
											</a>
										</li>
										<li className="nav-item">
											<a href="/sign-in" className="nav-link">
												Sign in
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</header>
		</>
	);
};

export default SellerHeader;
